import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import debounce from 'react-utils/debounce';
/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
import ReactCodeMirror from 'react-codemirror';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/edit/closebrackets';
import { getJsonString, EMPTY_JSON_BLOCK } from '../../utils/jsonUtils';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CodeMirrorThemeNames } from '../../../../utils/CodeMirrorTheme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class JSONInput extends Component {
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  constructor(props) {
    super(props);
    this.updateValue = jsonStr => {
      let value;
      if (!jsonStr) {
        // It's ok if they clear the editor, but we don't want to try to
        // JSON.parse an empty string because it'll error.
        this.setState({
          validValue: {},
          invalidJson: false
        });
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        this.props.onChange({});
      } else {
        try {
          value = JSON.parse(jsonStr);
          this.setState({
            validValue: value,
            invalidJson: false
          });
          /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
          this.props.onChange({
            properties: value
          });
        } catch (e) {
          this.setState({
            invalidJson: true
          });
        }
      }
    };
    this.onChange = ({
      value
    }) => {
      this.setState({
        json: value
      });
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      this.debouncedUpdate(value);
    };
    this.refCodemirror = ref => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      this.codemirror = ref && ref.codemirror;
    };
    this.state = {
      json: getJsonString(props.value, true),
      validValue: props.value
    };
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    this.debouncedUpdate = debounce(this.updateValue, 500);
  }
  componentDidMount() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      autoFocus
    } = this.props;
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    this.codemirror.refresh();
    if (autoFocus) {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      this.codemirror.focus();
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      if (this.state.json === EMPTY_JSON_BLOCK) {
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        this.codemirror.doc.setCursor({
          line: 1
        });
      }
    }
  }
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */

  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */

  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */

  render() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(ReactCodeMirror, {
        autoCloseBrackets: true,
        lineWrapping: true,
        matchBrackets: true,
        mode: "application/json",
        onChange: this.onChange,
        readOnly: false,
        refCodemirror: this.refCodemirror,
        style: {
          maxHeight: 300
        },
        theme: CodeMirrorThemeNames.DARK,
        width: "100%"
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */,
        value: this.state.json
        // Disables default behavior for tab, which codemirror v5 captures without consent
        ,
        extraKeys: {
          Tab: false
        }
      }), this.state.invalidJson && /*#__PURE__*/_jsx(Small, {
        use: "error",
        "data-test-id": "invalid-json-error",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.params.errors.invalidJson"
        })
      })]
    });
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */

JSONInput.propType = {
  autoFocus: PropTypes.string,
  value: PropTypes.string
};